import { useSuspenseInfiniteQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { majorClient } from '../client/majorClient';

type Options = {
};

const defaultOptions: Partial<Options> = {
};

const defaultPageSize = 10;

export const useInfiniteMajors = (params: Majors.GetListParams = {}, options: Partial<Options> = defaultOptions) => {
  
  const {
    data,
    ...rest
  } = useSuspenseInfiniteQuery({
    queryKey: [cacheKeys.getMajors, params],
    queryFn: ({ pageParam }) => majorClient.getMajors({
      ...params,
      limit: params.limit || defaultPageSize,
      offset: (pageParam - 1) * defaultPageSize,
    }),
    initialPageParam: 1,
    ...options,
    getNextPageParam: (lastPage, allPages) => {
      const totalPages = Math.ceil((lastPage?.data.count || 0) / (params.limit || defaultPageSize));
      const currentPage = allPages.length;
      if (currentPage < totalPages) {
        return currentPage + 1;
      }
      return undefined;
    },
  });

  const count = data?.pages[data.pages.length - 1]?.data?.count || 0;

  const majors = data?.pages.flatMap(page => page.data?.results || []) || [];

  return {
    ...rest,
    count,
    majors,
  };
};
